
import axios from "axios"

import { $userInfoBd } from "./store/user"
import { applyBlackMask, convertBytearrToImg } from './functions/converBytearrToImg';

import { defaultPath } from './routes/defaultPath';
import { user } from './routes/user';
import { card } from './routes/card';
import { toys } from './routes/toys';
import { missions } from './routes/missions';
import { achievements } from "./routes/achievements";

// Добавляем Telegram initData в заголовок каждого запроса для валидации на бэкенде
axios.interceptors.request.use((config) => {
    const initData = window?.Telegram?.WebApp?.initData;
    if (initData) {
        config.headers['X-Telegram-Init-Data'] = initData;
    }
    return config;
});

const cashImages: {[url: string]: string} = {}

export const API = {
    user,
    card,
    toys,
    missions,
    achievements,
    getImageData: async (id:string, type:'toys' | 'collections'| 'achievements' | 'stories',img_type?: 'masked' | 'unmasked') => {
        let url = '';

        switch (type) {
        case 'toys':
            url = `${defaultPath}image/toys/${id}`;
            break;
        case 'collections':
            url = `${defaultPath}image/collections/${id}`;
            break;
        case 'achievements':
            url = `${defaultPath}image/achievements/${id}`;
            break;
        case 'stories':
            url = `${defaultPath}images/stories/${id}`;
            break;
        default:
            throw new Error(`Unknown type: ${type}`);
        }

        const cashKey = `${url}?img_type=${img_type || 'unmasked'}`;
        
        if (cashImages[cashKey]) { 
            return cashImages[cashKey];
        }
        
        const res = await axios.get(url, {responseType: 'arraybuffer'});

        let response = convertBytearrToImg(res.data);

        if (img_type === 'masked') {
            response = await applyBlackMask(response);
        }

        cashImages[cashKey] = response;

        return response;

    },
    getCollections: async (collection_id?:string) => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.get(`${defaultPath}collections${collection_id ? `/toys/${collection_id}?user_id=${user_id}` : `?user_id=${user_id}`}`);

        return res.data;
    },
    getLeaders: async (period:'week' | 'all') => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.get(`${defaultPath}leaderboard?user_id=${user_id}${period === 'week' ? '&period=week' : ''}`);

        return res.data;
    },
    getTransactions: async (page:number) => {
        const user_id = $userInfoBd.getState()?.id;
        try {
            const res = await axios.get(`${defaultPath}bonus_transactions/${user_id}?page=${page}`);
        
            return res.data;
        } catch (error:any) {
            if (error.rsponse.status === 404) {
                return [];
            }
        }
    },
    getStories: async () => {
        const res = await axios.get(`${defaultPath}stories`);

        return res.data;
    },
    getStory: async (id: string): Promise<import('./types/stories').IStorieDetailResponse> => {
        const res = await axios.get(`${defaultPath}stories/${id}`);

        return res.data;
    }
}
